/**
 * PageFooter — rodapé "dados atualizados · Atualizar" das páginas de Marketing.
 * `onRefresh` deve refazer a busca (nunca recarregar a página).
 */
import Icon from './icons.jsx'

export default function PageFooter({ text, onRefresh }) {
  return (
    <footer className="dash-footer">
      <span>{text}</span>
      <span className="dash-footer-sep">·</span>
      <button className="dash-footer-refresh" onClick={onRefresh} type="button">
        <Icon n="refresh" s={11} />
        Atualizar
      </button>
    </footer>
  )
}
